import { DialogM } from "@common/components/alert/dialog/Dialog"
import { Menu3Point } from "@common/components/menu/Menu3Point"
import TextM from "@common/components/text/TextM"
import useLiveKitEventSender from "@common/hooks/livekit/useLiveKitEventSender"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setTodoActivities } from "@data/redux/actions/data"
import { activitiesService } from "@data/services/activitiesService"
import { schoolsService } from "@data/services/schoolsService"
import { liveService } from "@data/services/liveService"
import { findItemInListWithId } from "@data/utility/dataUtils"
import { useNavigation } from "@react-navigation/native"
import React, { useContext, useMemo, useRef, useState } from "react"
import { Dimensions, TouchableOpacity, Vibration, View } from "react-native"
import DraggableFlatList from "react-native-draggable-flatlist"
import { FlatList } from "react-native-gesture-handler"
import { ActivityIndicator } from "react-native-paper"
import { connect } from "react-redux"
import AvatarM from "../../common/components/avatar/AvatarM"
import { Checked } from "../../common/components/icons/IconsM"
import {
    SkillSetTitleFull,
    XPCount,
} from "../../common/components/statistics/Counters"
import DiagnosticModal from "../../common/liveMode/DiagnosticModal"
import { liveReportService } from "../../data/services/liveReportService"
import { hasRole } from "../../data/utility/ability"
import {
    getActivityRealizationItemColor,
    getTodaysFinishedActivities,
} from "../../data/utility/dataUtils"
import { boxedCardBorderStyle } from "../../reviewer/BoxedCardBorderStyle"
import TodoModal from "../../student/activity/todo/TodoModal"
import { RealizationsListItemContent } from "../../student/organize/list/RealizationsListItemContent"
import { IconTouchableRipple } from "./IconTouchableRipple"
import LiveAvatarM from "./LiveAvatarM"
import { SchoolSubjectBadge } from "./ProfilDetails"

export const calculateSumOfEstimatedTime = (dataArray, attribute) => {
    return dataArray?.reduce((sum, obj) => sum + obj[attribute], 0)
}

function StudentsListItem(props) {
    const {
        student,
        index,
        menuItems = [],
        isLoading,
        isLiveMode = false,
        additionalActions = [],
        style,
        isTutor = false,
        withTodo = false,
        soundMode = false,
        showLeftSection = true,
        chatButton = true,
        nav = null,
        onPressAdditionalActions = () => {},
    } = props

    const navigation = nav ?? useNavigation()
    const liveSession = props.currentLiveSession
    const dimensions = useContext(DimensionsContext)
    const width = withTodo
        ? Dimensions.get("window").width - 30
        : dimensions.width - 20
    const activityFinalizedCount =
        liveSession && props.isLive
            ? liveSession?.users?.find((u) => u.id === student?.id)?.statistics
                ?.today?.activities?.count
            : student?.statistics?.today?.activities?.count
    const isTutorsStudent =
        !!props.user?.students?.find((x) => x?.id === student?.id) ||
        liveSession?.users?.find((u) => u.id === student?.id)
    const isOnline = !!props.participants?.find((x) => x === student?.id)
    const draggableFlatListRef = useRef()
    const flatListRef = useRef()
    const [isTodoModalOpen, setIsTodoModalOpen] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const [isDiagnosticModalOpen, setIsDiagnosticModalOpen] = useState(false)
    const [
        studentLiveReportsWithDiagnostic,
        setStudentLiveReportsWithDiagnostic,
    ] = useState(null)
    const [isDiagnosticLoading, setIsDiagnosticLoading] = useState(false)
    const handleShowModal = () => setIsTodoModalOpen(!isTodoModalOpen)
    const todos = student?.todo_activities

    const finishedActivities = useMemo(
        () => getTodaysFinishedActivities(student),
        [student]
    )

    const [deleteOrIndexesRequest, setDeleteOrIndexesRequest] = useState(false)

    const onDeleteTodo = (todoId) => {
        // Check if student is in checkpoint and if the archived activity is the current activity
        const isInCheckpoint = props.ongoingCheckpointIds?.includes(student?.id)
        const currentActivityId = props.currentStudentActivity?.[student?.id]
        const isArchivingCurrentActivity = currentActivityId === todoId

        // If student is in checkpoint with this activity, show confirmation dialog first
        if (isInCheckpoint && isArchivingCurrentActivity) {
            DialogM.show({
                champion: "sam",
                variant: "main",
                text1: `${student?.display_name} est en plein point d'avancement avec Sam sur cette activité`,
                text2: "Souhaites-tu interrompre la conversation pour archiver cette activité ?",
                buttonText1: "Oui, interrompre et archiver",
                buttonColor1: theme.colors.primary,
                onPress: () => {
                    // Cancel the checkpoint first
                    const activeConversation =
                        student?.conversations?.[student?.conversations?.length - 1]

                    if (activeConversation?.id) {
                        props.apiRequest(
                            liveService.finishConversation,
                            { conversation_id: activeConversation.id },
                            {
                                interruption_reason: "activity_archived",
                                ended_at: new Date().toISOString(),
                            }
                        )
                    }

                    // Archive the activity
                    setDeleteOrIndexesRequest(true)
                    props.apiRequest(
                        activitiesService.deleteActivitiesTodo,
                        { student: student?.id },
                        { activity_ids: [todoId] }
                    )
                },
                buttonText2: "Non",
            })
        } else {
            // No checkpoint, show standard archive dialog
            DialogM.show({
                text1: "Veux-tu archiver cette activité ?",
                text2: "Tu pourras la restaurer depuis les activités archivées.",
                buttonText1: "Archiver",
                buttonColor1: theme.colors.primary,
                onPress: () => {
                    setDeleteOrIndexesRequest(true)
                    props.apiRequest(
                        activitiesService.deleteActivitiesTodo,
                        { student: student?.id },
                        { activity_ids: [todoId] }
                    )
                },
                buttonText2: "Annuler ",
            })
        }
    }

    const { sendLiveKitData: sendNewTodo } = useLiveKitEventSender()

    useApiStatus(activitiesService.deleteActivitiesTodo, null, true, (data) => {
        if (deleteOrIndexesRequest) {
            sendNewTodo(
                "deleteTodo",
                {
                    id: student?.id,
                    activity_ids: data?.deleted_activity_ids || [],
                },
                [student?.id]
            )
            setDeleteOrIndexesRequest(false)
        }
    })

    useApiStatus(
        activitiesService.activityTodoIndexesAsTutor,
        null,
        true,
        () => {
            if (deleteOrIndexesRequest) {
                sendNewTodo(
                    "newTodo",
                    {
                        id: student?.id,
                    },
                    [student?.id]
                )
                setDeleteOrIndexesRequest(false)
            }
        }
    )

    useApiStatus(
        liveReportService.getStudentLiveReportsWithDiagnostic,
        null,
        true,
        (data) => {
            setIsDiagnosticLoading(false)
            if (data?.[0]?.student?.id === student?.id) {
                setStudentLiveReportsWithDiagnostic({
                    ...studentLiveReportsWithDiagnostic,
                    [student?.id]: data,
                })
                setIsDiagnosticModalOpen(true)
            }
        },
        () => {
            setIsDiagnosticLoading(false)
            onPressAdditionalActions()
        }
    )

    const windowWidth = Dimensions.get("window").width

    const renderActionButtons = () => {
        return (
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingBottom: 10,
                    flex: 1,
                }}
            >
                <IconTouchableRipple
                    icon={"bullseye"}
                    label={"Activités"}
                    badgeCounter={activityFinalizedCount}
                    onPress={() => {
                        onPressAdditionalActions()
                        navigation.push("student", {
                            studentId: student?.id,
                        })
                    }}
                />
                <IconTouchableRipple
                    icon={"file-medical-alt"}
                    label={"Rapports Live"}
                    badgeCounter={student?.live_reports?.length}
                    onPress={() => {
                        onPressAdditionalActions()
                        navigation.push("live-reports", {
                            studentId: student?.id,
                        })
                    }}
                />
                {chatButton && (
                    <IconTouchableRipple
                        icon={"comment"}
                        label={"Messages"}
                        badgeCounter={
                            props.isLive
                                ? props.currentLiveSession
                                    .unread_private_messages_count[student?.id]
                                : props.user.live_sessions?.find((ls) =>
                                    ls?.students
                                        ?.map((u) => u?.id)
                                        ?.includes(student?.id)
                                )?.unread_private_messages_count[student?.id]
                        }
                        disabled={!isTutorsStudent}
                        onPress={() => {
                            if (props.isLiveMode) {
                                navigation.navigate("messages", {
                                    userId: student?.id,
                                })
                            } else {
                                navigation.navigate("messenger", {
                                    studentId: student?.id,
                                })
                            }
                        }}
                    />
                )}
                <IconTouchableRipple
                    icon={"heartbeat"}
                    label={"Diagnostic"}
                    disabled={isDiagnosticLoading}
                    onPress={() => {
                        if (studentLiveReportsWithDiagnostic?.[student?.id]) {
                            setIsDiagnosticModalOpen(true)
                        } else {
                            setIsDiagnosticLoading(true)
                            props.apiRequest(
                                liveReportService.getStudentLiveReportsWithDiagnostic,
                                { id: student?.id }
                            )
                        }
                    }}
                    loading={isDiagnosticLoading}
                />
                {additionalActions?.map((a, index) =>
                    a?.request ? (
                        a?.requestComponent ? (
                            <React.Fragment key={index}>
                                {a?.requestComponent}
                            </React.Fragment>
                        ) : (
                            <ActivityIndicator
                                key={index}
                                color={theme.colors.primary}
                                style={{ flex: 1 }}
                            />
                        )
                    ) : (
                        <IconTouchableRipple
                            key={index}
                            icon={a?.icon}
                            iconSize={a?.iconSize}
                            label={a?.label}
                            badgeCounter={a?.badgeCounter}
                            disabled={a?.disabled}
                            color={a?.color}
                            style={{
                                backgroundColor: a?.backgroundColor,
                            }}
                            onPress={a?.onPress}
                        />
                    )
                )}
            </View>
        )
    }

    useApiStatus(activitiesService.deleteActivitiesTodo, null, true, (data) => {
        sendNewTodo(
            "deleteTodo",
            {
                id: student?.id,
                activity_ids: data?.deleted_activity_ids || [],
            },
            [student?.id]
        )
    })

    useApiStatus(
        schoolsService.removeStudentFromClassroom,
        "L'élève a bien été retiré de la classe",
        true
    )

    const currentActivityId = props.currentStudentActivity?.[student?.id]

    const renderItem = ({ item, drag, isActive }) => {
        const color = getActivityRealizationItemColor(
            item,
            props.currentStudentActivity?.[student?.id] ||
            props.currentActivity?.id
        )
        const status =
            item?.locked_at !== null ||
            (props.updatedActivityEventData?.locked_at !== null &&
                props.updatedActivityEventData?.activity_id === item?.id)
                ? "En cours"
                : item?.started_at !== null
                    ? "Commencée"
                    : null
        const activityTemplate = findItemInListWithId(
            item?.activity_template_id,
            props.activityTemplates
        )
        const formData = activityTemplate?.steps
        const activityType = formData?.find((step) => step.type === "photo")
            ? "photo"
            : "audio"

        return (
            <TouchableOpacity
                onPress={() => {
                    setSelectedItem(item)
                    if (status) {
                        navigation.push("activity-result", {
                            activityIds: [item?.id],
                            studentId: student?.id,
                        })
                    } else handleShowModal()
                }}
                disabled={isActive}
                style={{
                    backgroundColor: theme.colors.white,
                    borderRadius: 10,
                    borderWidth: 1,
                    borderColor: color,
                    marginRight: 10,
                    minWidth: 160,
                }}
            >
                <>
                    <RealizationsListItemContent
                        activity={item}
                        color={color}
                        dragButton={drag}
                        schoolSubject={findItemInListWithId(
                            item?.school_subject_id,
                            props.schoolSubjects
                        )}
                        noBorder={true}
                        currentUser={props.user}
                        student={student}
                        noClass={props.user?.id === item?.student_id}
                        todo={true}
                        updatedActivityEventData={
                            props.updatedActivityEventData
                        }
                        activityType={activityType}
                        liveMode
                        currentActivityId={currentActivityId}
                    />
                    {props.deleteTodoRequest &&
                        props.deleteTodoRequestActivityId === item?.id && (
                            <ActivityIndicator
                                animating={true}
                                color={theme.colors.primary}
                                size={14}
                                style={{
                                    position: "absolute",
                                    top: -2,
                                    right: -2,
                                }}
                            />
                        )}
                </>
            </TouchableOpacity>
        )
    }

    const renderLeftSection = () => {
        return (
            <>
                <TouchableOpacity
                    style={{
                        flex: 1,
                    }}
                    onPress={() => {
                        if (!isTutor) {
                            onPressAdditionalActions()
                            navigation.replace("student-profil", {
                                studentId: student?.id,
                                withActions: true,
                                prevScreen: "menu/students",
                            })
                        }
                    }}
                >
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            flex: 1,
                        }}
                    >
                        {isLiveMode ? (
                            <LiveAvatarM user={student} />
                        ) : (
                            <AvatarM
                                user={student}
                                style={{ marginRight: 2 }}
                                size={50}
                            />
                        )}

                        <View
                            style={{
                                marginLeft: 5,
                                flex: 1,
                            }}
                        >
                            <TextM
                                fontWeight="SemiBold"
                                fontSize={16}
                                wrap
                                color={theme.colors.primary}
                            >
                                {student?.display_name}
                            </TextM>
                            <TextM fontWeight="Medium" style={{}} fontSize={12}>
                                {student?.profile?.class}
                            </TextM>
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                }}
                            >
                                {student?.prioritized_school_subjects?.map(
                                    (item) => {
                                        return (
                                            <SchoolSubjectBadge
                                                key={item?.id}
                                                schoolSubject={item}
                                            />
                                        )
                                    }
                                )}
                            </View>
                        </View>
                    </View>
                </TouchableOpacity>

                <View
                    style={{
                        alignItems: "flex-end",
                        justifyContent: "center",
                        flex: 1,
                    }}
                >
                    {menuItems?.length > 0 ? (
                        !isLoading ? (
                            <Menu3Point menuItems={menuItems} />
                        ) : (
                            <ActivityIndicator color={theme.colors.primary} />
                        )
                    ) : (
                        <></>
                    )}
                    {withTodo && !isTutor ? (
                        <>
                            <DraggableFlatList
                                horizontal={true}
                                data={todos ?? []}
                                onDragBegin={() => Vibration.vibrate(50)}
                                onDragEnd={({ data }) => {
                                    props.setTodoActivities(data)
                                    setDeleteOrIndexesRequest(true)
                                    if (hasRole(props.user, "student"))
                                        props.apiRequest(
                                            activitiesService.activityTodoIndexesAsStudent,
                                            {},
                                            {
                                                todo_activities_ids: data.map(
                                                    (todo) => todo.id
                                                ),
                                            }
                                        )
                                    else
                                        props.apiRequest(
                                            activitiesService.activityTodoIndexesAsTutor,
                                            { id: student?.id },
                                            {
                                                todo_activities_ids: data.map(
                                                    (todo) => todo.id
                                                ),
                                            }
                                        )
                                    Vibration.vibrate(50)
                                }}
                                keyExtractor={(item) => item?.id}
                                contentContainerStyle={{
                                    alignItems: "stretch",
                                    paddingVertical: 16,
                                }}
                                style={{
                                    width:
                                        dimensions.width < 800
                                            ? dimensions.width / 2
                                            : dimensions.width / 1.2,
                                }}
                                ref={draggableFlatListRef}
                                ListEmptyComponent={() => (
                                    <>
                                        <TextM
                                            style={{
                                                textAlign: "center",
                                                marginLeft: 10,
                                                alignSelf: "center",
                                            }}
                                        >
                                            Aucune activité à faire
                                        </TextM>
                                    </>
                                )}
                                ListHeaderComponent={() => (
                                    <>
                                        <FlatList
                                            horizontal={true}
                                            data={finishedActivities}
                                            containerStyle={{}}
                                            style={{ overflow: "hidden" }}
                                            ref={flatListRef}
                                            renderItem={(item) => {
                                                const color =
                                                    getActivityRealizationItemColor(
                                                        item?.item,
                                                        props
                                                            .currentStudentActivity?.[
                                                            student?.id
                                                            ]
                                                    )

                                                return (
                                                    <TouchableOpacity
                                                        style={{
                                                            marginRight: 10,
                                                        }}
                                                        onPress={() => {
                                                            onPressAdditionalActions()
                                                            navigation.push(
                                                                "activity-result",
                                                                {
                                                                    activityIds:
                                                                        [
                                                                            item
                                                                                .item
                                                                                ?.id,
                                                                        ],
                                                                    studentId:
                                                                    student?.id,
                                                                }
                                                            )
                                                        }}
                                                    >
                                                        <RealizationsListItemContent
                                                            activity={item.item}
                                                            schoolSubject={findItemInListWithId(
                                                                item?.item
                                                                    ?.school_subject_id,
                                                                props.schoolSubjects
                                                            )}
                                                            noClass={true}
                                                            currentUser={
                                                                props.user
                                                            }
                                                            student={student}
                                                            updatedActivityEventData={
                                                                props.updatedActivityEventData
                                                            }
                                                            style={{
                                                                opacity: 0.5,
                                                                minWidth: 160,
                                                                borderRadius: 10,
                                                                borderWidth: 1,
                                                                borderColor:
                                                                color,
                                                            }}
                                                            liveMode
                                                            currentActivityId={
                                                                currentActivityId
                                                            }
                                                        />
                                                        <Checked
                                                            size={24}
                                                            style={{
                                                                position:
                                                                    "absolute",
                                                                top: 0,
                                                                right: 0,
                                                            }}
                                                        />
                                                    </TouchableOpacity>
                                                )
                                            }}
                                        />
                                    </>
                                )}
                                ListFooterComponent={() => (
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                            height: "100%",
                                        }}
                                    >
                                        <IconTouchableRipple
                                            icon={"plus"}
                                            iconSize={26}
                                            style={{
                                                marginLeft: 30,
                                                paddingHorizontal: 10,
                                            }}
                                            label={"Ajouter"}
                                            onPress={() => {
                                                if (
                                                    todos.length <
                                                    props.maxTodoActivities
                                                ) {
                                                    onPressAdditionalActions()
                                                    navigation.push(
                                                        "new-todo",
                                                        {
                                                            studentId:
                                                            student?.id,
                                                        }
                                                    )
                                                } else {
                                                    onPressAdditionalActions()
                                                    DialogM.show({
                                                        champion: "zoe",
                                                        text1: `Tu ne peux pas dépasser ${props.maxTodoActivities} activités dans ta liste`,
                                                        text2: "C'est l'heure de faire un peu de ménage ! Archive les activités qui ne sont plus utiles.",
                                                    })
                                                }
                                            }}
                                        />
                                        {todos.length > 0 &&
                                            (props.deleteActivitiesTodoAsTutorRequest ? (
                                                <ActivityIndicator
                                                    color={theme.colors.primary}
                                                    size={"small"}
                                                />
                                            ) : (
                                                <IconTouchableRipple
                                                    icon={"archive"}
                                                    iconSize={26}
                                                    style={{
                                                        marginLeft: 30,
                                                        marginRight: 30,
                                                        paddingHorizontal: 10,
                                                    }}
                                                    label={"Archiver"}
                                                    onPress={() => {
                                                        onPressAdditionalActions()
                                                        DialogM.show({
                                                            champion: "zoe",
                                                            text1: `Archiver toutes les activités de la liste de ${student?.display_name} ?`,
                                                            text2: "Tu pourras les restaurer depuis les activités archivées.",
                                                            buttonText1:
                                                                "Archiver tout",
                                                            buttonColor1:
                                                            theme.colors.primary,
                                                            onPress: () => {
                                                                props.apiRequest(
                                                                    activitiesService.deleteActivitiesTodo,
                                                                    {
                                                                        student:
                                                                        student?.id,
                                                                    },
                                                                    {
                                                                        activity_ids:
                                                                            todos?.map(
                                                                                (
                                                                                    t
                                                                                ) =>
                                                                                    t.id
                                                                            ) ||
                                                                            [],
                                                                    }
                                                                )
                                                            },
                                                            buttonText2:
                                                                "Annuler",
                                                        })
                                                    }}
                                                />
                                            ))}
                                    </View>
                                )}
                                renderItem={renderItem}
                            />
                        </>
                    ) : (
                        !isTutor && (
                            <View style={{ marginRight: 8 }}>
                                <SkillSetTitleFull
                                    title={student?.student_title}
                                    icon={student?.student_title_icon}
                                    skillSetId={student?.title_skill_set_id}
                                    right
                                    small
                                />
                                <XPCount
                                    count={student?.xp}
                                    right
                                    style={{ marginRight: 3 }}
                                    small
                                />
                            </View>
                        )
                    )}
                </View>
            </>
        )
    }

    return (
        <View
            key={index}
            style={{
                width,
                marginBottom: 10,
                backgroundColor: theme.colors.white,
                borderRightWidth: soundMode ? 2 : 1,
                borderLeftWidth: soundMode ? 2 : 1,
                borderTopWidth: soundMode ? 2 : 1,
                borderBottomWidth: soundMode ? 2 : 1,
                borderColor: !isOnline
                    ? theme.colors.lightMore
                    : !soundMode && !isTutor
                        ? theme.colors.purple
                        : theme.colors.success,
                alignSelf: "center",
                ...boxedCardBorderStyle,
                ...style,
            }}
        >
            <>
                {
                    <View
                        style={{
                            width,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingHorizontal: 10,
                            paddingVertical: 12,
                        }}
                    >
                        {showLeftSection && renderLeftSection()}

                        {!isTutor && windowWidth > 800 && (
                            <View
                                style={{
                                    borderColor: theme.colors.lightMore,
                                    flex: withTodo ? 0.9 : 3,
                                    height: "100%",
                                    flexDirection: "row",
                                    justifyContent: "space-around",
                                    ...(showLeftSection && {
                                        borderLeftWidth: 1,
                                    }),
                                }}
                            >
                                {renderActionButtons()}
                            </View>
                        )}
                        {withTodo && !isTutor && (
                            <Menu3Point
                                menuItems={[
                                    {
                                        title: "Activités",
                                        onPress: () => {
                                            onPressAdditionalActions()
                                            navigation.push("student", {
                                                studentId: student?.id,
                                                initialTabRealizations: true,
                                            })
                                        },
                                    },
                                    {
                                        title: "Rapports",
                                        onPress: () => {
                                            onPressAdditionalActions()
                                            navigation.push("live-reports", {
                                                studentId: student?.id,
                                            })
                                        },
                                    },
                                    {
                                        title: "Messages",
                                        onPress: () => {
                                            onPressAdditionalActions()
                                            if (props.isLiveMode) {
                                                navigation.navigate(
                                                    "messages",
                                                    {
                                                        userId: student?.id,
                                                    }
                                                )
                                            } else {
                                                navigation.navigate(
                                                    "messenger",
                                                    {
                                                        studentId: student?.id,
                                                    }
                                                )
                                            }
                                        },
                                    },
                                ]}
                            />
                        )}
                    </View>
                }
                {!isTutor && windowWidth <= 800 && (
                    <View
                        style={{
                            width,
                            flexDirection: "row",
                            justifyContent: "space-around",
                        }}
                    >
                        {renderActionButtons()}
                    </View>
                )}
            </>
            {isTodoModalOpen && (
                <TodoModal
                    isOpen={isTodoModalOpen}
                    handleShowModal={handleShowModal}
                    item={selectedItem}
                    navigation={navigation}
                    onDeleteTodo={onDeleteTodo}
                    studentId={student?.id}
                    schoolSubject={findItemInListWithId(
                        selectedItem?.school_subject_id,
                        props.schoolSubjects
                    )}
                />
            )}
            {isDiagnosticModalOpen && (
                <DiagnosticModal
                    visible={isDiagnosticModalOpen}
                    onDismiss={() => setIsDiagnosticModalOpen(false)}
                    liveReports={
                        studentLiveReportsWithDiagnostic?.[student?.id]
                    }
                    student={student}
                    editable={false}
                />
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        sessions: state.data.currentUser?.object?.sessions,
        participants: state.liveMode?.liveParticipants,
        inCallUsers: state.liveMode?.inCallUsers,
        schoolSubjects: state.data.staticData?.school_subjects,
        getSessionsRequest: state.api.getLiveSession?.request,
        isLive: state.liveMode.isLiveModeEnabled,
        notes: state.data.tutors?.notes,
        getNotesRequest: state.api.getNotes?.request,
        deleteActivitiesTodoAsTutorRequest:
        state.api.deleteActivitiesTodo?.request,
        maxTodoActivities: state.data.staticData?.max_todo_activities,
        updatedActivityEventData: state.activity?.updatedActivityEventData,
        activityTemplates: state.data.staticData?.activity_templates,
        currentStudentActivity: state.liveMode?.currentStudentActivity,
        getStudentLiveReportsWithDiagnosticRequest:
        state.api.getStudentLiveReportsWithDiagnostic?.request,
        ongoingCheckpointIds: state.liveMode?.ongoingCheckpointIds,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setTodoActivities,
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentsListItem)
